<header class="header">
  <div class="header__container">
    <h1 class="header__title">{{heading}}</h1>
    <button *ngIf="!closeListener && !disableClose" class="header__close-btn" mat-dialog-close><mat-icon>close</mat-icon></button>
    <button *ngIf="closeListener" class="header__close-btn" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>
</header>